import React from "react";
import { ImageGolSmilesBrand } from "../assets/ImageGolSmilesBrand";
import { IconClose } from "../assets/IconClose";
import { getLink } from "../../utils";
import { LanguageSelector } from "./LanguageSelector";
import { redirectGolEnviroment } from "../utils/redirectEnviroment";
import { getDestRefSource, getRedirectURISource } from "../../utils/LinkHelper";

export function LoginHeader() {
    const isSrcParam = (): boolean => {
      const params = new URLSearchParams(window.location.search);

      const sourceParam = params.get('src') || getRedirectURISource() || getDestRefSource();

      return sourceParam === 'gol';
    }

    const handleBrandClick = () => {
      const sourceIsGol = isSrcParam();

      if(sourceIsGol) {
        window.location.href = redirectGolEnviroment();
        return;
      }

      window.location.href = getLink('home');
    }

    const handleCloseButtonClick = () => {
      const sourceIsGol = isSrcParam();
      
      if(sourceIsGol) {
        window.location.href = redirectGolEnviroment();
        return;
      }

      window.location.href = getLink('home');
    }
  
    return (
      <div className="header-container">
        <div className="left-side">
          <div className="brand-button" onClick={handleBrandClick}>
            <ImageGolSmilesBrand  />
          </div>

          <LanguageSelector className="custom-lang-selector" />
        </div>

        <div className="right-side">
          <div className="close-icon" onClick={handleCloseButtonClick}>
            <IconClose />
          </div>
        </div>
      </div>
    )
}